import { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const REVENUE_PROOF_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_brand-embodied/artifacts/0dcf10ac319699c9_IMG_8236%202.jpg";

const GREG_PROOF_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_brand-embodied/artifacts/47790dceae78599d_Screenshot%202026-10-07%20at%204.10.37%E2%80%AFPM.png";

const NATALIE_VIEWS_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_brand-embodied/artifacts/9f1c8e77cf54cc03_IMG_6049.jpg";

const QUOTES = [
  {
    quote:
      "Working with Dani 1:1 has literally transformed my life. I went from a broke college dropout to starting my own brand, making $3,400 in my first month and now gearing up for my first $10k month. And all this in 45 days! Thank you forever bro.",
    name: "Mark T.",
    role: "1:1 client",
    stars: true,
  },
  {
    quote:
      "Hey Dani, quick update! Since our last group coaching cohort, I was able to launch my first $3k offer, make 4 sales and generate over $12k in my first month alone! Not to mention my low ticket made me $3,405 too! This is just the beginning but a HUGE thank you.",
    name: "Group client",
    role: "Message to Dani after the last cohort",
    stars: false,
  },
  {
    quote:
      "Dude I just had to say I've never made more money OR been happier in my life than now. I'm 3 months into the offer we created for my brand and I've made over $43k alone with it! Not to mention my low ticket + webinar sales. Referred you to 3 buddies who I know you'll help them too. Thx homie! Keep crushing it.",
    name: "Melissa F.",
    role: "Group mentorship client",
    stars: false,
  },
  {
    quote:
      "3 weeks after working with Dani and I've tripled my personal brand revenue. I'm making 4-5k in monthly revenue and doing my own private coaching. Unreal work bro.",
    name: "Josh E.",
    role: "1:1 client",
    stars: true,
  },
];

export const Testimonials = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelected(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    onSelect();
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi]);

  return (
    <section
      id="results"
    className="bg-bone py-24 lg:py-32"
    data-testid="testimonials-section"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <Eyebrow light>Words from past clients</Eyebrow>
            <h2 className="mt-6 max-w-2xl font-mont text-3xl font-bold leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Quiet work,{" "}
              <em className="italic text-forest">visible</em> results.
            </h2>
          </div>
        </div>
      </Reveal>

      <div className="relative mt-12" data-testid="testimonials-carousel">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {QUOTES.map((q, i) => (
              <div
                key={q.name}
                className="min-w-0 shrink-0 grow-0 basis-full px-3 sm:px-14 lg:px-24"
              >
                <figure
                  className="mx-auto flex h-full flex-col justify-between border border-ink/10 bg-white p-8 lg:p-12"
                  data-testid={`testimonial-card-${i + 1}`}
                >
                  <div>
                    {q.stars && (
                      <div
                        className="flex gap-1"
                        aria-label="Rated 5 out of 5 stars"
                        data-testid={`testimonial-stars-${i + 1}`}
                      >
                        {[0, 1, 2, 3, 4].map((s) => (
                          <svg
                            key={s}
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="#1F4D3A"
                            aria-hidden="true"
                          >
                            <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7-6.2-3.7-6.2 3.7 1.6-7L2 9.2l7.1-.6z" />
                          </svg>
                        ))}
                      </div>
                    )}
                    <blockquote
                      className={`font-mont text-lg font-light italic leading-relaxed text-ink sm:text-2xl ${
                        q.stars ? "mt-5" : ""
                      }`}
                    >
                      &ldquo;{q.quote}&rdquo;
                    </blockquote>
                  </div>
                  <figcaption className="mt-8 border-t border-ink/10 pt-5">
                    <p className="text-sm font-medium text-ink">{q.name}</p>
                    {q.role && (
                      <p className="mt-1 text-xs uppercase tracking-[0.18em] text-stone">
                        {q.role}
                      </p>
                    )}
                  </figcaption>
                </figure>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6">
          <button
            data-testid="carousel-prev-button"
            aria-label="Previous testimonial"
            onClick={() => emblaApi?.scrollPrev()}
            className="flex h-10 w-10 items-center justify-center border border-ink/15 text-ink transition-colors duration-300 hover:bg-ink hover:text-bone"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.6" />
            </svg>
          </button>
          <div className="flex items-center gap-2">
            {Array.from({ length: QUOTES.length }).map((_, i) => (
              <button
                key={i}
                data-testid={`carousel-dot-${i + 1}`}
                aria-label={`Go to slide ${i + 1}`}
                onClick={() => emblaApi?.scrollTo(i)}
                className={`h-1.5 transition-all duration-300 ${
                  selected === i
                    ? "w-6 bg-forest"
                    : "w-1.5 bg-ink/20 hover:bg-ink/40"
                }`}
              />
            ))}
          </div>
          <button
            data-testid="carousel-next-button"
            aria-label="Next testimonial"
            onClick={() => emblaApi?.scrollNext()}
            className="flex h-10 w-10 items-center justify-center border border-ink/15 text-ink transition-colors duration-300 hover:bg-ink hover:text-bone"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M5 2l5 5-5 5" stroke="currentColor" strokeWidth="1.6" />
            </svg>
          </button>
        </div>
      </div>
      <p className="mt-8 text-xs text-stone" data-testid="testimonials-disclaimer">
        Shared by clients as they wrote them — context, never a promise of
        your results.
      </p>

      <div className="mt-14" data-testid="revenue-examples">
        <Eyebrow light>Examples of what can happen</Eyebrow>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3">
          <figure className="border border-ink/10 bg-white p-3">
            <img
              src={GREG_PROOF_IMG}
              alt="Last month's revenue of $7,073.76 thanks to private coaching from @daguti_"
              className="w-full"
              data-testid="example-greg-revenue"
            />
            <figcaption className="px-2 py-3 text-xs uppercase tracking-[0.18em] text-stone">
              <span className="font-medium text-ink">— Greg H.</span> ·
              $7,073.76 month
            </figcaption>
          </figure>
          <figure className="border border-ink/10 bg-white p-3">
            <img
              src={REVENUE_PROOF_IMG}
              alt="Revenue dashboard showing $25,395.73 total revenue in one month"
              className="w-full"
              data-testid="example-client-revenue"
            />
            <figcaption className="px-2 py-3 text-xs uppercase tracking-[0.18em] text-stone">
              April 2026 Sales by Dani
            </figcaption>
          </figure>
          <figure className="border border-ink/10 bg-white p-3">
            <img
              src={NATALIE_VIEWS_IMG}
              alt="Instagram analytics showing 13,314,249 views in 90 days with 0% from ads"
              className="w-full"
              data-testid="example-natalie-views"
            />
            <figcaption className="px-2 py-3 text-xs uppercase tracking-[0.18em] text-stone">
              13 million views in 90 days from Natalie, past client
            </figcaption>
          </figure>
        </div>
        <p className="mt-6 text-xs text-stone">
          Real screenshots from real clients — examples of what can happen,
          never promises.
        </p>
      </div>
    </div>
      </section>
  );
};

export default Testimonials;
